<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
  <div class="card ">
    <div class="card-header">
      <div class="float-end fit-content h-100 d-flex flex-column align-items-end mt-2 gap-2">
      </div>
      <h5 class="card-title">Peridos</h5>
      <h6 class="card-subtitle text-muted">Configura los períodos de vacaciones o días festivos</h6>

    </div>
    <div class="card-body p-4">

      <div class="mb-3 d-flex align-items-center justify-content-end gap-2">
        <div *ngIf="holidayEnable" class="text-muted small mb-0">
          Haz clic en el icono para visualizar el calendario
        </div>

        <button *ngIf="holidayEnable" type="button" class="btn btn-link p-0 text-primary"
          (click)="openCalendarModal()" aria-label="Abrir calendario" title="Abrir calendario">
          <i class="fa-solid fa-calendar-days fs-4"></i>
        </button>
      </div>

      <div *ngIf="holidayData && holidayData.length > 0 ; else emptyState" class="d-flex flex-column gap-2">
        <ng-container *ngFor="let period of holidayData ; let i = index">

        <button type="button" *ngIf="holidayEnable"  (click)="selectPeriod(i)"
          class="btn text-start p-3 rounded-3 border d-flex align-items-center gap-3">

          <div class="d-flex align-items-center justify-content-center rounded-3 text-white flex-shrink-0 bg-primary"
            [ngClass]="i === 0 ? 'bg-primary' : i === 1 ? 'bg-success' : i === 2 ? 'bg-danger' : 'bg-secondary'"
            style="width: 34px; height: 34px;">
            <span class="fw-semibold">{{ i + 1 }}</span>
          </div>

          <div class="flex-grow-1">
            <div class="fw-semibold text-dark">Periodo {{ i + 1 }}</div>
            <div class="text-muted small">
              {{ period.startDay }}/{{ period.startMonth }} · {{ period.startHour }}
              →
              {{ period.endDay }}/{{ period.endMonth }} · {{ period.endHour }}
            </div>
          </div>

          <div class="d-flex gap-2">
            <i class="fa-solid fa-pen-to-square" (click)="openCalendarModal(i)"></i>
            <!-- <i class="fa-solid fa-calendar-days  " (click)="openCalendarModal()"></i> -->
            <i class="fa-solid fa-trash text-danger" (click)="deletePeriod(i)"></i>
          </div>

        </button>
         </ng-container>


        <button type="button" (click)="addPeriod()"
          class="btn btn-outline-primary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
          style="border-style: dashed;">
          <i class="fa-solid fa-plus"></i>
          <span>Añadir periodo</span>
        </button>
      </div>

      <ng-template #emptyState>
        <div class="text-muted small mb-3">No hay períodos configurados</div>
        <button type="button" (click)="addPeriod()"
          class="btn btn-outline-secondary w-100 py-3 rounded-3 d-flex align-items-center justify-content-center gap-2"
          style="border-style: dashed;">
          <i class="fa-solid fa-plus"></i>
          <span>Añadir periodo</span>
        </button>
      </ng-template>


    </div>
  </div>
</div>
